import { store } from '../store/store'

export default {
  checkAction: (pms) => {
    const action = store.getters.getPathActions ? store.getters.getPathActions.filter(item => item.value === pms) : 0
    return !!action.length
  }
}



// WEBPACK FOOTER //
// ./src/util/permissions.js